export default __webpack_public_path__ + "static/media/lightSwap.bfffcc99.png";